import { Injectable } from '@angular/core';
import { GlobalHttpClient } from '../global.http.client';
import { BaseService } from './base.service';

@Injectable()
export class CmsDialogService extends BaseService {
    constructor(http: GlobalHttpClient) {
        super(http);
    }

    getByDescription(description: string) {
        return this.http.get(`cmsDialog/${description}`);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/cms.dialog.service.ts